import React, { Fragment, useState, useMemo } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import SpaceList from './spaces/space-list'
import SpaceAction from './spaces/space-action'


const VenueSpaces = (props = {}) => {
  const [action, setAction] = useState('view')
  const [spaceId, setSpaceId] = useState(null)
  const { venueId } = props;

  const renderSpaceByAction = useMemo(() => {
    if (action === 'view') return <SpaceList setSpaceId={setSpaceId} venueId={venueId} setAction={setAction} />
    return <SpaceAction spaceId={spaceId} action={action} venueId={venueId} setAction={setAction} />
  });

  return (
    <div className="bg-white py-6 px-10">
      <Fragment>
        {renderSpaceByAction}
      </Fragment>
    </div>
  );
};

VenueSpaces.propTypes = {
  venueId: PropTypes.number
};

const mapStateToProps = ({ venue }) => ({
  venueId: venue.details.id
})

export default connect(mapStateToProps)(VenueSpaces);
